










































































import { Component, Vue, Prop } from "vue-property-decorator";
import md5 from "js-md5";
import { serverInfo } from "@/req/shopManage";
import { SHOP_STATE_LIST, SHOP_COLUMNS } from "../config";

@Component({
  components: {},
})
export default class Logout extends Vue {
  public modal = false;
  public orderNum = "";
  public gameId: any = "";
  public gameList: any = [];
  public serverId: any = "";
  public serverList: any = [];
  public shopStateId: any = "";
  public shopStateList = SHOP_STATE_LIST;
  public signKey = "RMOTTem0jK6EZrGQjudkoeHLSbSTJ8Kt";
  public show(row, index) {
    this.orderNum = "";
    this.gameId = "";
    this.serverId = "";
    this.modal = true;
  }
  // 获取游戏区服列表
  public async gameChange(val) {
    this.serverId = "";
    this.serverList = [];
    if (this.gameId == "" || this.gameId == undefined) {
      return false;
    }
    const obj = {
      token: this.$fn.cookies.getToken(),
      game_id: this.gameId,
    };
    const res = await serverInfo(obj);
    if (res.code == 0) {
      this.serverList = res.data;
    }
  }
  // 导出表格
  public async save() {
    const sign = `game_id=${this.gameId == undefined ? "" : this.gameId}&id=${
      this.orderNum == undefined ? "" : this.orderNum
    }&server_id=${this.serverId == undefined ? "" : this.serverId}&status=${
      this.shopStateId || ""
    },&token=${this.$fn.cookies.getToken("token")}`;
    const signKey = `${sign}${this.signKey}`;
    const windowUrl = `${
      this.$HTTP_API.shopManage.commodityExcel
    }?${sign}&sign=${md5(signKey)}`;
    window.open(windowUrl);
    this.modal = false;
  }
}
